<template>
  <div class="animated revealUp">
      
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">{{ $t('edit') }} {{ $tc('unitofmeasurement', 2) }}</div>
      <router-link
        class="btn-blue"
        to="unit-of-measurment"
      >{{ $tc('unitofmeasurement', 2) }} {{ $tc('list', 2) }}</router-link>
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="uom_unit"
                name="uom"
                id="uom"
                v-validate="'required|alpha_spaces'"
              />
              <label>{{ $tc('unitofmeasurement', 2) }}</label>
            </div>
            <!-- <Tooltip :title="$t('unitofmeasurement_tooltip')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('uom')">{{ errors.first('uom') }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="uom_short_form"
                name="shortform"
                id="shortform"
                v-validate="'required|alpha_spaces'"
              />
              <label>{{ $tc('shortform', 2) }}</label>
            </div>
            <!-- <Tooltip :title="$t('shortform_tooltip')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('shortform')">{{ errors.first('shortform') }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="uom_description"
                name="desc"
                id="desc"
                v-validate="'required|alpha_spaces'"
              />
              <label>{{ $t('description') }}</label>
            </div>
            <!-- <Tooltip :title="$t('uom_description')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('desc')">{{ errors.first('desc') }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="d-flex align-self-center">
            <label class="mb-0 mr-3">{{ $t('hasparent') }}</label>
            <label class="ios-switch">
              <input type="checkbox" v-model="is_parent" class="ios-checkbox" checked />
              <span class="switch-slider"></span>
            </label>
          </div>
        </div>

        <div class="col-lg-3 col-xl-3 align-self-center mb-3" v-if="is_parent">
          <div class="dropdown-curve-container">
            <label
                          :class="
                            fc_parent_label ? 'shift-up' : ''
                          "
                          >{{ $t('parent') }}</label
                        >
            <b-dropdown :text="fc_parent_label" variant="dropdown-curve" class="w-100">
              <b-dropdown-item
                v-for="(fc,fcIndex) in ms_unit_of_measurement"
                :key="fcIndex"
                href="#"
                :disabled="fc.uom_unit==uom_unit"
                @click="fc_parent_id=fc.uom_id;fc_parent_label=fc.uom_unit;uom_short_form_dis='=1'+fc.uom_short_form"
                name="selectparent"
                id="selectparent"
              >{{ fc.uom_unit }}</b-dropdown-item>
              <!-- <b-dropdown-item href="#">unit 2</b-dropdown-item>
                <b-dropdown-item href="#">unit 3</b-dropdown-item>
              <b-dropdown-item href="#">unit4</b-dropdown-item>-->
              <!-- <b-dropdown-item href="#" v-for="(loop , key) in 20" :key="key">Something else here</b-dropdown-item> -->
            </b-dropdown>
            <p class="error_message">
              <span v-if="submitted && fc_parent_label == ''">{{ messageparent }}</span>
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-3 align-self-center mb-3" v-if="is_parent">
          <div class="d-flex align-items-center">
            <div class="input-material">
              {{uom_short_form_dis}}
              <input
                v-model="uom_formula"
                name="formula"
                id="formula"
                v-validate="'required|numeric'"
                type="text"
                placeholder="."
              />
              <label>{{ $t('formula') }}</label>
            </div>
            <!-- <Tooltip :title="$t('uom_formula_tooltip')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('formula')">{{ errors.first('formula') }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="d-flex align-self-center">
            <label class="mb-0 mr-3">{{ $t('active') }}</label>
            <label class="ios-switch">
              <input type="checkbox" v-model="uom_is_active" class="ios-checkbox" checked />
              <span class="switch-slider"></span>
            </label>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button @click.prevent.stop="onFinalSubmit(false)" class="btn-blue">{{ $t('update') }}</button>
          <button @click.prevent.stop="onResetForm()" class="btn-black">{{ $t('reset') }}</button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="unit-of-measurment"
          >{{ $t('back') }}</b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import MasterService from "@/services/MasterService";
//import PosFnbService from "@/services/PosFnbService";
export default {
  components: { Multiselect },
  data() {
    return {
      messageparent: "Please Select Parent.",
      uom_id: 0,
      uom_unit: "",
      uom_short_form: "",
      uom_short_form_dis: "",
      submitted: false,
      uom_short_form2: "",
      uom_parent_id: 0,
      uom_formula: "",
      uom_description: "",
      uom_is_active: true,

      ms_unit_of_measurement: [],

      fc_category: "",
      fc_parent_id: 0,
      fc_parent_label: "",
      //    fc_is_active: true,
      is_parent: false
      // uom_id: ""
    };
  },
  beforeMount() {
    this.uom_id = this.$route.query.uom_id;
  },
  mounted() {
    this.getVendorsList();
  },
  methods: {
    getVendorsList: function() {
      let payload = {
        tableName: "ms_unit_of_measurement"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.ms_unit_of_measurement = data.Records;
            this.ms_unit_of_measurement.map(x => {
              if (this.uom_id == x.uom_id) {
                this.uom_unit = x.uom_unit;
                this.uom_short_form = x.uom_short_form;
                this.fc_parent_id = x.uom_parent_id;
                this.uom_formula = x.uom_formula;
                this.uom_description = x.uom_description;
                //     this.uom_is_active = x.uom_is_active == true ? "Y" : "N";
                this.uom_is_active = x.uom_is_active == "Y" ? true : false;
              }
              this.ms_unit_of_measurement.map(y => {
                if (this.fc_parent_id > 0 && this.fc_parent_id == y.uom_id) {
                  this.is_parent = true;
                  this.fc_parent_label = y.uom_unit;
                }
              });
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    onResetForm: function() {
      this.uom_unit = "";
      this.uom_short_form = "";
      this.uom_id = "";
      this.fc_parent_id = 0;
      this.fc_parent_label = "";
      this.uom_formula = "";
      this.uom_description = "";
      this.is_parent = false;
      this.uom_is_active = true;
    },
    onFinalSubmit(flag) {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        console.log("valid :", valid);
        if (valid) {
          console.log("uom_unit.length :", this.uom_unit.length);
          if (this.uom_unit.length > 0) {
            // this.submitted = true;
            // var is_parent_final = this.is_parent;
            // console.log("this.is_parent :", this.is_parent);
            // console.log("is_parent_final :", this.is_parent_final);
            if (this.is_parent == false) {
              this.uom_formula = null;
              this.fc_parent_id = 0;
            } else {
              this.uom_formula = this.uom_formula;
              this.fc_parent_id = this.fc_parent_id;
            }
            let payload = {
              uom_unit: this.uom_unit,
              uom_short_form: this.uom_short_form,
              uom_formula: this.uom_formula,
              uom_description: this.uom_description,
              fc_parent_id: this.fc_parent_id,
              uom_is_active: this.uom_is_active,
              uom_id: this.uom_id
            };
            console.log(payload);

            MasterService.editUnitOfMeasurementOperation(payload)
              .then(response => {
                const { data } = response;
                if (data && data.status) {
                  this.onResetForm();
                  this.$router.push({
                    path: "/master/unit-of-measurment"
                  });
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch(err => {
                this.$toasted.show(error);
              });
          }
        }
      });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/UnitofMesurementComponents/editUnitOfMeasurement.vue